module.exports = __webpack_public_path__ + "64c47097874f4f12a79b905a87bb310e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/background.jpg
// module id = 145
// module chunks = 0